export const quickNews = [
  "最新更新：古装剧组凌晨收工路透释出，服化细节登上今日热搜",
  "新料快讯：秋季音乐节阵容官宣，压轴嘉宾身份引发全网猜测",
  "专题上新：中秋档影片口碑榜更新，三部新片冲进前十",
  "今日头条：年度古装大剧定档预告发布，两小时播放量破千万",
  "更新提醒：综艺路透合集已补充第 12 组现场图",
];

export const entryLinks = [
  { label: "剧集速览", icon: "ri-movie-2-line", desc: "当日剧组动态" },
  { label: "综艺路透", icon: "ri-live-line", desc: "录制现场合集" },
  { label: "音乐现场", icon: "ri-music-2-line", desc: "演出与新歌" },
  { label: "今日热搜", icon: "ri-fire-line", desc: "讨论热度榜" },
  { label: "专题合辑", icon: "ri-folder-open-line", desc: "按题材整理" },
  { label: "更新日历", icon: "ri-calendar-line", desc: "蹲点不错过" },
];

export const heroSideFlashes = [
  { time: "10:24", text: "定档预告释出，相关话题冲上热搜前列" },
  { time: "09:58", text: "秋季音乐节压轴嘉宾线索再添一条" },
  { time: "09:31", text: "中秋档排片表更新，黄金场次已开放预售" },
];

export const headlines = [
  {
    id: "hl-1",
    tag: "今日头条",
    title: "年度古装大剧《长夜山河》定档预告释出，服化细节冲上热搜前列",
    summary:
      "预告片上线两小时播放量破千万，剧中实景取景地与服饰纹样成为讨论焦点，相关话题在同一天内两次回到热搜榜前列，蹲进展的网友把评论区顶成了考据现场。",
    time: "12 分钟前",
    reads: "8.6 万",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20film%20set%20interior%20with%20a%20vintage%20camera%20rig%20and%20warm%20tungsten%20lighting%2C%20dust%20floating%20in%20the%20air%2C%20cinematic%20behind%20the%20scenes%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20long%20shadows%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20high%20detail%2C%20elegant%20magazine%20composition&width=1200&height=800&seq=hl-main-01&orientation=landscape",
  },
  {
    id: "hl-2",
    tag: "综艺",
    title: "秋季音乐节阵容官宣，压轴嘉宾的身份成了当天最大悬念",
    summary:
      "官宣海报只放出剪影与三个关键词，评论区从下午一直猜到深夜，多个相关词条先后进入热搜榜。",
    time: "38 分钟前",
    reads: "5.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20washed%20in%20warm%20golden%20spotlights%20with%20light%20haze%2C%20silhouette%20of%20a%20microphone%20stand%2C%20entertainment%20editorial%20photography%2C%20deep%20amber%20and%20cream%20color%20palette%2C%20soft%20glow%2C%20elegant%20minimalist%20composition%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=hl-sub-02&orientation=landscape",
  },
  {
    id: "hl-3",
    tag: "音乐",
    title: "国风企划新单曲上线半小时登顶，评论区被路人听感刷屏",
    summary:
      "编曲里的一段古琴采样被反复讨论，制作团队在深夜放出了幕后花絮，二次传播量持续走高。",
    time: "1 小时前",
    reads: "3.9 万",
    image:
      "https://readdy.ai/api/search-image?query=Studio%20desk%20with%20vintage%20headphones%20and%20mixing%20console%20knobs%2C%20warm%20late%20afternoon%20window%20light%2C%20editorial%20still%20life%20photography%2C%20cream%20and%20caramel%20tones%2C%20shallow%20depth%20of%20field%2C%20clean%20minimal%20background%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=hl-sub-03&orientation=landscape",
  },
  {
    id: "hl-4",
    tag: "影视",
    title: "两部现实题材新片同日开机，主创班底成为讨论焦点",
    summary:
      "片方在同一天放出两组开机现场照，取景城市与拍摄周期首次对外披露，行业向讨论明显升温。",
    time: "2 小时前",
    reads: "2.7 万",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20wooden%20clapperboard%20resting%20on%20a%20warm%20linen%20surface%2C%20soft%20directional%20daylight%2C%20editorial%20still%20life%20photography%2C%20cream%20and%20terracotta%20palette%2C%20minimal%20clean%20background%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=hl-sub-04&orientation=landscape",
  },
];

export const updateCategories = ["全部", "剧集", "综艺", "音乐", "影视", "活动"];

export const latestUpdates = [
  {
    id: "up-1",
    category: "剧集",
    title: "《长夜山河》第二季正式开机，主创团队集体亮相横店",
    summary:
      "片方公布了完整主创名单与预计拍摄周期，第一季遗留的两条主线将在续作中给出回应，评论区已经开始押剧情走向。",
    time: "18 分钟前",
    isNew: true,
  },
  {
    id: "up-2",
    category: "综艺",
    title: "这档慢综艺放出第三期预告，飞行嘉宾名单只露出半边脸",
    summary:
      "预告剪得很碎，只留下一个侧影和一句台词，节目组在评论区保持沉默，网友把过往路透翻了个遍。",
    time: "46 分钟前",
    isNew: true,
  },
  {
    id: "up-3",
    category: "音乐",
    title: "秋季巡演首批城市公布，长三角三站开票即告售罄",
    summary:
      "主办方表示后续会评估加场，歌单里保留了两首尚未正式发行的新歌，现场观众成了第一批听到的人。",
    time: "1 小时前",
    isNew: false,
  },
  {
    id: "up-4",
    category: "影视",
    title: "中秋档口碑榜更新，三部新片评分隔夜拉开差距",
    summary:
      "榜首与第三名之间的分差在一天之内扩大到明显区间，排片结构随之调整，黄金场次出现集中倾斜。",
    time: "2 小时前",
    isNew: false,
  },
  {
    id: "up-5",
    category: "活动",
    title: "年度剧集发布会敲定时间，到场名单分三批对外放出",
    summary:
      "首批名单以幕后主创为主，演员部分留到临近才公布，媒体报名通道开放两小时就收到了超额申请。",
    time: "3 小时前",
    isNew: false,
  },
  {
    id: "up-6",
    category: "剧集",
    title: "都市题材新剧杀青照流出，取景地成打卡新去处",
    summary:
      "杀青当日剧组在取景街区合影，周边商户的客流量随之上升，几个取景点被本地网友整理成路线。",
    time: "4 小时前",
    isNew: false,
  },
  {
    id: "up-7",
    category: "综艺",
    title: "户外真人秀新一季定档，录制地点从海岛换到高原",
    summary:
      "节目组确认本季取消了固定棚内环节，全部在户外完成，嘉宾体能训练相关的花絮提前放出一段。",
    time: "5 小时前",
    isNew: false,
  },
  {
    id: "up-8",
    category: "音乐",
    title: "两张概念专辑同日上线，制作思路竟意外撞题",
    summary:
      "两张专辑都以「夜」为主题，编曲方向却完全不同，乐评人把这次撞题当成了一次公开的审美对照。",
    time: "6 小时前",
    isNew: false,
  },
];

export const topics = [
  {
    id: "tp-1",
    title: "中秋档观影专题",
    desc: "围绕档期口碑、排片与观众反馈，把当天新出的评价整理成一份可以快速扫读的观影参考。",
    count: "收录 18 条更新",
    tag: "影视",
    image:
      "https://readdy.ai/api/search-image?query=Rows%20of%20empty%20velvet%20cinema%20seats%20lit%20by%20warm%20amber%20light%2C%20moody%20editorial%20photography%2C%20cream%20and%20caramel%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=topic-cinema-01&orientation=landscape",
  },
  {
    id: "tp-2",
    title: "秋季穿搭观察",
    desc: "从品牌发布会与街拍里挑出有讨论度的细节，按单品归类，方便直接照着看。",
    count: "收录 24 条更新",
    tag: "时尚",
    image:
      "https://readdy.ai/api/search-image?query=Folded%20autumn%20knitwear%20stacked%20on%20a%20warm%20linen%20surface%20with%20dried%20foliage%2C%20soft%20natural%20light%2C%20editorial%20flat%20lay%20photography%2C%20cream%20and%20rust%20tones%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=topic-fashion-01&orientation=landscape",
  },
  {
    id: "tp-3",
    title: "综艺路透合集",
    desc: "把一整天流出的现场图按节目归类，只保留能确认时间与地点的部分，减少来回翻找。",
    count: "收录 31 条更新",
    tag: "综艺",
    image:
      "https://readdy.ai/api/search-image?query=Quiet%20street%20corner%20in%20soft%20morning%20haze%20beside%20a%20warm%20brick%20wall%2C%20documentary%20editorial%20photography%2C%20cream%20and%20amber%20palette%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=topic-street-01&orientation=landscape",
  },
  {
    id: "tp-4",
    title: "新剧开机盘点",
    desc: "汇总本月开机项目的班底、取景与周期，把零散信息拼成一张能对比的清单。",
    count: "收录 12 条更新",
    tag: "剧集",
    image:
      "https://readdy.ai/api/search-image?query=Folded%20paper%20script%20on%20a%20wooden%20table%20beside%20a%20cup%20of%20tea%2C%20warm%20window%20light%2C%20editorial%20still%20life%20photography%2C%20cream%20and%20caramel%20palette%2C%20minimal%20clean%20background%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=topic-script-01&orientation=landscape",
  },
];

export const trending = [
  { rank: 1, title: "古装剧服化道细节", heat: "98.2 万", trend: "up" },
  { rank: 2, title: "秋季音乐节压轴嘉宾", heat: "86.4 万", trend: "up" },
  { rank: 3, title: "中秋档口碑榜更新", heat: "74.1 万", trend: "flat" },
  { rank: 4, title: "国风新单曲登顶", heat: "61.7 万", trend: "up" },
  { rank: 5, title: "新剧开机路透", heat: "52.9 万", trend: "down" },
  { rank: 6, title: "慢综艺飞行嘉宾", heat: "44.3 万", trend: "flat" },
  { rank: 7, title: "巡演加场传闻", heat: "38.6 万", trend: "up" },
  { rank: 8, title: "发布会首批名单", heat: "29.5 万", trend: "down" },
];

export const trustSteps = [
  {
    icon: "ri-radar-line",
    title: "实时收录",
    desc: "当天流出的动态按时间先后进入待整理池，不提前排序，先保证不漏。",
  },
  {
    icon: "ri-filter-3-line",
    title: "交叉核对",
    desc: "一条动态至少有两个可追溯的来源才会进入更新列表，含糊内容只做标注不当作结论。",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "归类成题",
    desc: "同一件事的零散更新会收进一个专题，方便顺着时间线往下读，不用反复翻找。",
  },
];

export const faqs = [
  {
    q: "黑料网1 的更新频率是怎样的？",
    a: "更新列表按滚动方式维护，当天有新动态就会补进对应条目；今日头条与快讯在同一时间轴上推进，专题会随着事件发酵同步扩充。",
  },
  {
    q: "今日头条是按什么挑选出来的？",
    a: "主要看当天讨论热度的变化速度和话题持续时间，同时参考来源的可追溯程度。热度高但来源单薄的内容会留在更新列表，不进入头条。",
  },
  {
    q: "快讯、头条和专题有什么区别？",
    a: "快讯是最短的时间线提示，头条是当天最值得先看的一条，专题则把同一件事的多条更新按时间顺序收在一起，适合蹲完整进展。",
  },
  {
    q: "站内内容可以直接转载吗？",
    a: "站内整理部分可以注明来源后转载。涉及第三方图片与素材的，请以原发布方的授权说明为准，我们不代为授权。",
  },
  {
    q: "页面看起来能点但没反应，是坏了吗？",
    a: "当前版本为静态展示页，按钮与筛选、折叠等交互可以正常使用，涉及提交与登录的部分尚未接入，后续版本会逐步开放。",
  },
];

export const footerGroups = [
  {
    title: "今日内容",
    links: ["今日头条", "最新更新", "新料快讯", "今日热搜"],
  },
  {
    title: "专题合辑",
    links: ["影视专题", "综艺专题", "音乐专题", "活动专题"],
  },
  {
    title: "关于本站",
    links: ["整理流程", "常见问题", "内容来源", "联系方式"],
  },
];